import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export default function LoadingMarketDataSkeleton({
  nums = 5,
}: {
  nums?: number;
}) {
  return (
    <div className="flex flex-col gap-8 mt-5">
      <SkeletonTheme baseColor="#c0bebe" highlightColor="#444">
        {new Array(nums).fill(1).map((_, index) => {
          return (
            <div
              key={index}
              className="flex justify-between items-center h-10"
            >
              <div className="flex gap-3">
                <Skeleton
                  circle
                  containerClassName="w-10 h-10 flex"
                  height="100%"
                />
                <div className="flex flex-col justify-center gap-1">
                  <Skeleton containerClassName="w-20 h-6 flex" />
                  <Skeleton containerClassName="w-16 h-3 flex" />
                </div>
              </div>
              <div className="flex gap-6">
                <div className="flex flex-col items-end gap-1">
                  <Skeleton containerClassName="w-16 h-6 flex" />
                  <Skeleton containerClassName="w-8 h-3 flex" />
                </div>
                <Skeleton containerClassName="w-16 h-[100%] flex self-center" />
              </div>
            </div>
          );
        })}
      </SkeletonTheme>
    </div>
  );
}
